export default "__VITE_ASSET__D1nNW1HK__"